import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      height: '100vh',
    },
    leftPanel: {
      [theme.breakpoints.up('sm')]: {
        height: '100%',
      },
    },
    leftPanelContainer: {
      padding: theme.spacing(4),
      paddingTop: theme.spacing(17),

      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(4),
        paddingTop: theme.spacing(18),
        paddingBottom: theme.spacing(18),
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(10),
        paddingTop: theme.spacing(18),
        paddingBottom: theme.spacing(18),
      },
    },
    rightPanel: {
      position: 'relative',
      height: '100%',
      backgroundColor: '#f8f9fa',

      [theme.breakpoints.up('sm')]: {
        borderLeft: '1px solid #e0e0e0',
      },
    },
    rightPanelContainer: {
      padding: theme.spacing(4),
      paddingTop: theme.spacing(8),

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
        paddingTop: theme.spacing(14),
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(10),
        paddingTop: theme.spacing(14),
      },
    },
    docuSignContainer: {
      backgroundColor: '#FFFFFF',
      height: '100%',

      '& iframe': {
        border: 'none',
        width: '100%',
        height: '100%',
      },

      [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(8),
      },
    },
    overflowPanel: {
      [theme.breakpoints.up('sm')]: {
        overflow: 'auto',
        height: '100%',
      },
    },
    infoBox: {
      border: '1px solid #e0e0e0',
      borderRadius: theme.spacing(2),
      padding: theme.spacing(3),
    },
    title: {
      fontWeight: 500,
      color: '#333333',
      marginBottom: theme.spacing(3),
    },
    list: {
      paddingLeft: 0,
    },
    listItem: {
      display: 'flex',
      alignItems: 'flex-start',
      listStyle: 'none',
    },
    listItemBullet: {
      width: 6,
      height: 6,
      flexShrink: 0,
      borderRadius: '50%',
      backgroundColor: '#666666',
      marginTop: theme.spacing(0.75),
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(0.75),
    },
    banner: {
      backgroundColor: '#e3f2fd',
      border: '1px solid #90caf9',
      marginBottom: theme.spacing(4),
    },
    sectionTitle: {
      fontWeight: 500,
      marginBottom: theme.spacing(2),
    },
    preferencesTitle: {
      fontWeight: 500,
      marginBottom: theme.spacing(1),
    },
    formActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(2),
      marginTop: theme.spacing(4),
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      padding: theme.spacing(2),
      paddingRight: theme.spacing(10),
      backgroundColor: '#FFF',
      borderTop: '1px solid #E3E8ED',
      zIndex: 1000,
    },
    loadingSpinner: {
      backgroundColor: '#FFF',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 100,
    },
  })
);

export default useStyles;
